import { defineStore } from 'pinia'
import { ref } from 'vue'

/** Whether the "New page" step is open; the step is mounted once in `App.vue`. */
export const useCreateContentStore = defineStore('create-content', () => {
  const pageStepOpen = ref(false)

  /** Opens the step that asks which planned page to write. */
  function showPageStep(): void {
    pageStepOpen.value = true
  }

  function hide(): void {
    pageStepOpen.value = false
  }

  return { pageStepOpen, showPageStep, hide }
})
